import api from './api';

const PROJECT_CACHE_PREFIX = 'projects:';

const invalidateProjectCaches = (projectId = null) => {
  api.invalidateCache(PROJECT_CACHE_PREFIX, 'reports:dashboard', 'reports:project:');

  if (projectId !== null && projectId !== undefined) {
    api.invalidateCache(`${PROJECT_CACHE_PREFIX}detail:${projectId}`);
  }
};

const projectService = {
  getProjects: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) params.append(key, filters[key]);
    });
    const query = params.toString();
    const response = await api.cachedGet(`/projects?${query}`, {}, {
      cacheKey: `${PROJECT_CACHE_PREFIX}list:${query}`,
      ttlMs: 30 * 1000
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.cachedGet(`/projects/${id}`, {}, {
      cacheKey: `${PROJECT_CACHE_PREFIX}detail:${id}`,
      ttlMs: 30 * 1000
    });
    return response.data;
  },

  create: async (projectData) => {
    const response = await api.post('/projects', projectData);
    invalidateProjectCaches(response.data?.project?.id ?? null);
    return response.data;
  },

  update: async (id, projectData) => {
    const response = await api.put(`/projects/${id}`, projectData);
    invalidateProjectCaches(id);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/projects/${id}`);
    invalidateProjectCaches(id);
    return response.data;
  },

  addTask: async (projectId, taskData) => {
    const response = await api.post(`/projects/${projectId}/tasks`, taskData);
    invalidateProjectCaches(projectId);
    return response.data;
  },

  updateTask: async (taskId, taskData) => {
    const response = await api.put(`/projects/tasks/${taskId}`, taskData);
    invalidateProjectCaches();
    return response.data;
  },

  deleteTask: async (taskId) => {
    const response = await api.delete(`/projects/tasks/${taskId}`);
    invalidateProjectCaches();
    return response.data;
  },

  addMilestone: async (projectId, milestoneData) => {
    const response = await api.post(`/projects/${projectId}/milestones`, milestoneData);
    invalidateProjectCaches(projectId);
    return response.data;
  },

  addExpense: async (projectId, expenseData) => {
    const response = await api.post(`/projects/${projectId}/expenses`, expenseData);
    invalidateProjectCaches(projectId);
    return response.data;
  },

  getDashboard: async () => {
    const response = await api.cachedGet('/projects/dashboard', {}, {
      cacheKey: `${PROJECT_CACHE_PREFIX}dashboard`,
      ttlMs: 15 * 1000
    });
    return response.data;
  },
};

export default projectService;
